"use client"

import { X } from "lucide-react"
import { NavList } from "./NavList"

type OpenState = Record<string, boolean>

export function MobileSidebar({
  open,
  onClose,
  pathname,
  isAdmin,
  isDeveloper,
  openSections,
  setOpenSections,
  openGroups,
  setOpenGroups,
}: {
  open: boolean
  onClose: () => void
  pathname: string
  isAdmin: boolean
  isDeveloper: boolean
  openSections: OpenState
  setOpenSections: (next: OpenState) => void
  openGroups: OpenState
  setOpenGroups: (next: OpenState) => void
}) {
  if (!open) return null

  return (
    <div className="lg:hidden fixed inset-0 z-50">
      <button
        aria-label="Zamknij menu"
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      <div className="absolute left-0 top-0 h-full w-80 max-w-[85vw] bg-white/95 dark:bg-zinc-900/90 backdrop-blur-xl shadow-2xl flex flex-col rounded-r-2xl border-r border-zinc-200/70 dark:border-zinc-800">
        <div className="h-16 px-4 border-b border-zinc-200/70 dark:border-zinc-800 flex items-center justify-between">
          <div className="font-semibold text-gray-900 dark:text-white">Menu</div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 text-zinc-600 dark:text-zinc-300"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar py-6 px-3">
          <NavList
            pathname={pathname}
            isAdmin={isAdmin}
            isDeveloper={isDeveloper}
            collapsed={false}
            openSections={openSections}
            setOpenSections={setOpenSections}
            openGroups={openGroups}
            setOpenGroups={setOpenGroups}
            variant="mobile"
            onNavigate={onClose}
          />
        </div>
      </div>
    </div>
  )
}
